import { render } from "./headerContrat.vue?vue&type=template&id=63412f60"
import script from "./headerContrat.vue?vue&type=script&lang=ts"
export * from "./headerContrat.vue?vue&type=script&lang=ts"
script.render = render

export default script